import "./index.css";

import { cn } from "@/lib/utils";
import ProjectCard from "@/components/ProjectCard";
import { useEffect } from "react";
import { Badge } from "@/components/ui/badge";

import Biocon from "@public/projects/biocon.ico";
import Biotech from "@public/projects/biotech.png";
import BiotechFoundation from "@public/projects/biotech.foundation.png";
import BiotechIndustries from "@public/projects/biotech.industries.png";
import Mrbs from "@public/projects/mrbs.png";
import Mendeleev150 from "@public/projects/mendeleev150.jpg";
import Outline from "@public/projects/outline.png";
import ChemLab from "@public/projects/chem-lab.jpg";
import SerovaCareers from "@public/projects/serova.careers.jpeg";

export function App() {
  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove("light", "dark");
    const systemTheme = window.matchMedia("(prefers-color-scheme: dark)")
      .matches
      ? "dark"
      : "light";
    root.classList.add(systemTheme);
  }, []);

  return (
    <div
      className={cn(
        "container mx-auto p-8 text-center",
        "flex flex-col gap-8 justify-center",
      )}
    >
      <h1 className="text-4xl font-bold">
        Проекты факультета биотехнологий Университета ИТМО
      </h1>
      <div className="flex flex-row gap-8 flex-wrap justify-center">
        {/* <ProjectCard
          href="https://biocon.international"
          title="BIOCON"
          description="International Biotechnology Conference"
          logo={Biocon}
        /> */}
        <ProjectCard
          href="https://biotech.itmo.ru"
          title="Биотех ИТМО"
          description="Факультет биотехнологий университета ИТМО"
          logo={Biotech}
          imageClassName="aspect-[2/1] w-auto"
        />
        <ProjectCard
          href="https://biotech.foundation"
          title="Biotech Foundation"
          description="Biotech.Foundation"
          logo={BiotechFoundation}
          imageClassName="aspect-[2/1] w-auto"
        />
        <ProjectCard
          href="https://biotech.industries"
          title="Biotech Industries"
          description="Создаем инновации в биотех-индустрии"
          logo={BiotechIndustries}
          imageClassName="aspect-[2/1] w-auto"
        />
        <ProjectCard
          href="https://booking.cedne.ru"
          title="Booking"
          description="Система бронирования помещений факультета"
          logo={Mrbs}
          imageClassName="aspect-[13/5] w-auto"
        />
        <ProjectCard
          href="https://mendeleev150.cedne.ru"
          title="Mendeleev 150"
          description="Храним наследие МВК"
          logo={Mendeleev150}
          imageClassName="aspect-[3/2] w-auto"
        />
        <ProjectCard
          href="https://outline.cedne.ru"
          title="Outline"
          description="База знаний факультета биотехнологий"
          logo={Outline}
        />
        {/* <ProjectCard
          href="https://ched.cedne.ru"
          title="Ched"
          description="Приложение для обучения химии (ВКР и НИР от ПИШ)"
          logo={
            <Badge className="text-2xl font-bold relative aspect-video h-16">
              CHED
            </Badge>
          }
        />
        <ProjectCard
          href="https://chem-lab.cedne.ru"
          title="Chem-Lab"
          description="НИР 322126 ассистивные технологии обучения химии лиц с ДЦП"
          logo={ChemLab}
          imageClassName="aspect-[53/50] w-auto"
        /> */}
        {/* <ProjectCard
          href="https://serova.careers"
          title="SEROVA.CAREERS"
          description="Веб-сайт Надежды Серовой - карьерного консультанта"
          logo={SerovaCareers}
        /> */}
      </div>
    </div>
  );
}

export default App;
